export default __webpack_public_path__ + "static/media/IMG_1716.cc55f035.jpg";